export const getQueryParam = (path: string) => {
  let queryObj = new Map()
  const queryString = path.split('?')[1]

  if (queryString != null) {
    queryObj = queryString
      .split('&')
      .reduce<Map<string, string>>((prev, curr) => {
        const [key, value] = curr.split('=')
        prev.set(key, value)
        return prev
      }, new Map())

    return queryObj
  }

  return queryObj
}
